module.exports = __webpack_public_path__ + "media/images/analytics-0a0a3ee2981ca08c3eb1bcb0b4c33d7a.svg";